import { useMediaQuery } from "react-responsive";
import "./TopHeader.css";
import refunnelLogo from "./assets/refunnelLogo.svg";

const TopHeader = (props) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    <div className="top-header-container">
      <div className="top-header-main">
        <a
          href="https://www.refunnel.com/"
          target="_blank"
          rel="noreferrer"
          className="top-header-brand"
          aria-label="Refunnel — Creator marketing platform"
        >
          <img src={refunnelLogo} alt="Refunnel Logo" />
          <span className="brand-name">REFUNNEL</span>
          {!isMobile && (
            <>
              <span className="brand-dot" aria-hidden="true">
                ·
              </span>
              <span className="brand-tagline">Creator marketing platform</span>
            </>
          )}
        </a>

        <a
          href="https://meetings-na2.hubspot.com/maxwell-lewis/refunnel-demo"
          target="_blank"
          rel="noreferrer"
          className="book-demo-link"
        >
          <span>Book a demo</span>
          <span className="book-demo-arrow" aria-hidden="true">
            →
          </span>
        </a>
      </div>
    </div>
  );
};

export default TopHeader;
